import React from 'react'
import './Home.css';
import Product from './Product.js';

function Home() {
    return (
        <div className="home">
            <div className="home_container">
                <img className="home_image" src="https://images-na.ssl-images-amazon.com/images/G/01/AmazonExports/Events/2020/HolidayDeals/Desktop/Fuji_TallHero_HolidayDeals_en_US_1x._CB414278668_.jpg" alt="" />
                 <div className="home_row">
                     <Product id="1" title="my favourite book" price="19" rating={3} image="https://images-na.ssl-images-amazon.com/images/I/41Ag4WE7uyL._AC_UL160_.jpg" />
                     <Product id="2" title="DualSense Wireless Controller" price="230" rating={5} image="https://m.media-amazon.com/images/I/71qYy+o4DUL._AC_UY218_.jpg" />
                  </div>
                 <div className="home_row">
                     <Product id="3" title="my favourite book" price="19" rating={3} image="https://m.media-amazon.com/images/I/613HESgMbAL._AC_UY218_.jpg" />
                     <Product id="4" title="my favourite book" price="19" rating={3} image="https://m.media-amazon.com/images/I/81SGb5l+lZL._AC_UY218_.jpg" />
                     <Product id="5" title="my favourite book" price="19" rating={3} image="https://m.media-amazon.com/images/I/81mh84MM6qL._AC_UY218_.jpg" />
                     
                 </div>
                 <div className="home_row">
                     <Product id="6" title="my favourite book" price="19" rating={3} image="https://m.media-amazon.com/images/I/71916r38cNL._AC_UY218_.jpg" />
                     
                 </div>
            </div>
        </div>
    )
}

export default Home
